<template>
    <span @click="clearCache">{{ buttonText }}</span>
</template>

<script>
    export default {
        name: 'CacheClear',
        data() {
            return {
                buttonText: 'Clear Cache'
            }
        },
        methods: {
            async clearCache() {
                this.buttonText = 'Clearing Cache...';
                try {
                    // Unregister all service workers
                    if ('serviceWorker' in navigator) {
                        const registrations = await navigator.serviceWorker.getRegistrations();
                        
                        await Promise.all(
                            registrations.map(registration => registration.unregister())
                        );
                    }
                    
                    // Clear all caches
                    if ('caches' in window) {
                        const cacheNames = await caches.keys();
                        await Promise.all(
                            cacheNames.map(cacheName => caches.delete(cacheName))
                        );
                    }
                    
                    // Clear IndexedDB (optional)
                    await this.clearIndexedDB();
                    
                    setTimeout(() => {
                        window.location.href = window.location.origin + '?cache_cleared=' + Date.now();
                    }, 2000);
                    
                } catch (error) {
                    this.buttonText = 'Clear Cache';
                } finally {
                    this.buttonText = 'Clear Cache';
                }
            },
            async clearIndexedDB() {
                return new Promise((resolve) => {
                    if (!window.indexedDB) {
                        resolve();
                        return;
                    }

                    // This is a simple approach - you might want to be more specific
                    const databases = ['laravel-pwa', 'workbox'];
                    let completed = 0;
                    
                    databases.forEach(dbName => {
                        const request = indexedDB.deleteDatabase(dbName);
                        request.onsuccess = () => {
                            completed++;
                            if (completed === databases.length) resolve();
                        };
                        request.onerror = () => {
                            completed++;
                            if (completed === databases.length) resolve();
                        };
                    });
                    
                    if (databases.length === 0) resolve();
                });
            },
        }
    }
</script>